import { useContext } from "react";
import { PermissionsContext } from "../contexts";

/**
 * Hook to access the permissions context
 * Provides permission checking utilities for RBAC
 *
 * @returns {Object} Permissions context value
 * @returns {string[]} permissions - Array of permission strings
 * @returns {boolean} loading - Whether permissions are still loading
 * @returns {boolean} isSuperAdmin - Whether the user is a super admin
 * @returns {Function} hasPermission - Check if user has specific permission
 * @returns {Function} canCreate - Check if user can create in a module
 * @returns {Function} canRead - Check if user can read in a module
 * @returns {Function} canUpdate - Check if user can update in a module
 * @returns {Function} canDelete - Check if user can delete in a module
 * @returns {Function} canAccess - Check if user has any permission for a module
 *
 * @example
 * const { canCreate, canDelete, hasPermission } = usePermissions();
 *
 * if (canCreate("users")) {
 *   // Show create button
 * }
 *
 * if (hasPermission("grade", "update")) {
 *   // Show edit button
 * }
 */
export const usePermissions = () => useContext(PermissionsContext);
